<template>
    <div id="component_dashboard_root">
        <h1>{{$t('components.dashboard.welcome')}}</h1>
        <div class="row mt-5">
            <div class="col-sm-12">
                <div class="row">
                    <!-- Stocklist -->
                    <div class="col-sm-12 col-md">
                        <div class="card card-body text-center summary-box" @click="openWindow(resolveStocklistLink(), false)">
                            <h5 class="text-center text-wellis-gold">{{$t('components.stocklist.title')}}</h5>
                            <div class="w-100">
                                <p class="text-center mt-3 mb-0 font-weight-bold" v-if="summary.stock != null">
                                    {{summary.stock}} {{$t('product-s')}}
                                </p>
                                <i class="spinner-border text-wellis-gold" v-else></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md" v-if="$store.getters['authStore/fromUSA']">
                        <div class="card card-body text-center summary-box" @click="openWindow({name: 'app.stocklist.transit'}, false)">
                            <h5 class="text-center text-wellis-gold">{{`${$t('components.stocklist.title')} ${$t('components.stocklist-transit.title')}`}}</h5>
                            <div class="w-100">
                                <p class="text-center mt-3 mb-0 font-weight-bold" v-if="summary.transit != null">
                                    {{summary.transit}} {{$t('product-s')}}
                                </p>
                                <i class="spinner-border text-wellis-gold" v-else></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md" v-else>
                        <div class="card card-body text-center summary-box" @click="openWindow(resolveShopOrdLink(), false)">
                            <h5 class="text-center text-wellis-gold">{{$t('components.shopord.title')}}</h5>
                            <div class="w-100">
                                <p class="text-center mt-3 mb-0 font-weight-bold" v-if="summary.shopord != null">
                                    {{summary.shopord}} {{$t('product-s')}}
                                </p>
                                <i class="spinner-border text-wellis-gold" v-else></i>
                            </div>
                        </div>
                    </div>
                    <!-- Last order -->
                    <div class="col-sm-12 col-md">
                        <div class="card card-body text-center summary-box" @click="openWindow(summary.last_order.link)">
                            <h5 class="text-center text-wellis-gold">{{$t('components.dashboard.summary.order')}}</h5>
                            <div class="w-100">
                                <p class="text-center font-weight-bold mt-3 mb-0" v-if="summary.last_order != null">{{summary.last_order.value}}</p>
                                <i class="spinner-border text-wellis-gold" v-else></i>
                            </div>
                        </div>
                    </div>
                    <!-- Last shipping -->
                    <div class="col-sm-12 col-md">
                        <div class="card card-body text-center summary-box" @click="openWindow(summary.last_shipment.link)">
                            <h5 class="text-center text-wellis-gold">{{$t('components.dashboard.summary.shipment')}}</h5>
                            <div class="w-100">
                                <p class="text-center mt-3 mb-0" v-if="summary.last_shipment != null">
                                <p class="text-center font-weight-bold mt-3 mb-0" v-if="summary.last_shipment != null">{{summary.last_shipment.value}}</p>
                                <i class="spinner-border text-wellis-gold" v-else></i>
                            </div>
                        </div>
                    </div>
                    <!-- Balance -->
                    <div class="col-sm-12 col-md">
                        <div class="card card-body  text-center summary-box" @click="openWindow(summary.balance.link)">
                            <h5 class="text-center text-wellis-gold">{{$t('components.dashboard.summary.balance')}}</h5>
                            <div class="w-100">
                                <p class="text-center mt-3 mb-0 font-weight-bold" v-if="summary.balance != null">
                                    {{summary.balance.details.value | toPrice(summary.balance.details.currency, false)}}
                                </p>
                                <i class="spinner-border text-wellis-gold" v-else></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-8" v-if="news.special.length > 0">
                    <div class="col-sm-12">
                        <h2>{{$t('components.news.special')}}</h2>
                        <div class="row">
                            <div class="col-sm-12 col-md-4" v-for="item in news.special" :key="'special_'+item.id+'_'+$store.getters['langStore/current']">
                                <NewsCard :item="item"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-8" v-if="news.latests.length > 0">
                    <div class="col-sm-12">
                        <h2>{{$t('components.news.latests')}}</h2>
                        <div class="row">
                            <div class="col-sm-12 col-md-4" v-for="item in news.latests" :key="'latests_'+item.id+'_'+$store.getters['langStore/current']">
                                <NewsCard :item="item"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-5 text-center" v-if="news.special.length > 0 || news.latests.length > 0">
                    <router-link class="w-25 btn btn-wos-real" :to="{name: 'app.news'}">
                        {{$t('components.news.btnShowMore')}}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccountApiService from "../../../api/account.api";
import NewsApiService from "@/api/news.api";
import NewsCard from "@/components/application/NewsCard";
import {EVENT_LANG_CHANGE} from "@/core/constants";

export default {
    name: "Dashboard",
    components: {NewsCard},
    data() {
        return {
            viewTitle: 'components.dashboard.title',
            summary: {
                stock: null,
                transit: null,
                shopord: null,
                last_order: null,
                last_shipment: null,
                balance: null,
            },

            news: {
                special: [],
                latests: []
            }
        }
    },

    mounted() {
        this.fetch();

        this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
            this.fetchNews();
        });
    },

    destroyed() {
        this.$eventBus.$off(EVENT_LANG_CHANGE);
    },

    methods: {
        fetch() {
            Promise.all([this.fetchSummary(), this.fetchNews()]);
        },

        fetchSummary() {
            return new Promise((resolve, reject) => {
                AccountApiService.summary()
                    .then(response => {
                        this.summary = response.data
                        resolve(response.data);
                    })
                    .catch(reject);
            });
        },

        async fetchNews() {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                await NewsApiService.get('ACTIVE', true)
                    .then(response => this.news.special = response.data.items)
                    .catch(reject);

                NewsApiService.limitedGet('ACTIVE', 3)
                    .then(response => {
                        this.news.latests = response.data.items;
                        resolve();
                    })
                    .catch(reject);
            });
        },

        openWindow(link, blank = true) {
            if (link) {
                return blank ? window.open(link, '_blank') : this.$router.push(link);
            }
        },

        resolveStocklistLink() {
            if (this.$store.getters['configStore/getStocklistModuleStatus'] && !this.$store.getters['configStore/getMixedStockModuleStatus']) {
                return {name: 'app.stocklist'};
            } else {
                return {name: 'app.stock-mixed'};
            }
        },

        resolveShopOrdLink() {
            if (this.$store.getters['configStore/getShopOrdModuleStatus'] && !this.$store.getters['configStore/getMixedStockModuleStatus']) {
                return {name: 'app.shopord'};
            } else {
                return {name: 'app.stock-mixed'};
            }
        }
    }
}
</script>

<style scoped>
.summary-box {
    cursor: pointer;
    box-shadow: 0.4rem 0.4rem 0.6rem rgba(0, 0, 0, 0.1) !important;
}

.summary-box:hover {
    box-shadow: 0.1rem 0.1rem 0.7rem #b89453 !important;
}
</style>
